import React, { useEffect } from "react";
import toastError from "../../errors/toastError";

import { Button, Divider, Typography } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

const LocationPreview = ({
  image,
  link,
  description,
  latitude,
  longitude,
  name,
  address,
}) => {
  useEffect(() => {}, [
    image,
    link,
    description,
    latitude,
    longitude,
    name,
    address,
  ]);
  useEffect(() => {}, [image, link, description]);

  const handleLocation = async () => {
    try {
      if (!link) return;
      window.open(link);
    } catch (err) {
      toastError(err);
    }
  };

  const hasImage = Boolean(image);
  const hasCoordinates =
    latitude !== undefined &&
    latitude !== null &&
    longitude !== undefined &&
    longitude !== null;

  return (
    <>
      <div
        style={{
          minWidth: "250px",
        }}
      >
        <div>
          {hasImage && (
            <div style={{ float: "left" }}>
              <img
                src={image}
                alt="loc"
                onClick={handleLocation}
                style={{ width: "100px" }}
              />
            </div>
          )}
          {(description ||
            (!hasImage && (name || address || hasCoordinates))) && (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <Typography
                style={{
                  marginTop: "12px",
                  marginLeft: "15px",
                  marginRight: "15px",
                  float: "left",
                }}
                variant="subtitle1"
                color="primary"
                gutterBottom
              >
                {description ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: description.replace("\\n", "<br />"),
                    }}
                  ></div>
                ) : (
                  <div>
                    {name && <div>{name}</div>}
                    {address && <div>{address}</div>}
                    {hasCoordinates && (
                      <div>{`Lat: ${latitude}, Lng: ${longitude}`}</div>
                    )}
                  </div>
                )}
              </Typography>
            </div>
          )}
          <div style={{ display: "block", content: "", clear: "both" }}></div>
          <div>
            <Divider />
            <Button
              fullWidth
              color="primary"
              onClick={handleLocation}
              disabled={!link}
            >
              {i18n.t("locationPreview.button")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationPreview;
